import React from "react";
import { FormComponent } from "../../../components/form/DynamicForm";
import { Form, Validators } from "../../../components/form/DynamicFormTs";
import Http from "../../../Http";
import {
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import { withRouter } from "react-router-dom";
import EnviarFacturaEmail from "./EnviarFacturaEmail";

class Facturar extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: "corte/one", saveUrl: "corte/save", backUrl: "/Catalogo" },
      new Form(
        [
          Form.Field("hidden", "id_guia", "", "", []),
          Form.Field("autocomplete", "g_folio", "Folio Guia", "", [], 4),
          Form.Field( "checkbox", "g_redocumentacion", "Redocumentacion", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_redocumentacion_folio", "Folio", "", [], 4, [], [], [], false, true),
          Form.Field( "date", "createdAt", "Fecha de Documentacion", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_origen", "Origen", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_destino", "Destino", "", [], 4, [], [], [], false, true),
          Form.Field( "checkbox", "g_autoservicio", "Autoservicio", "", [], 4, [], [], [], false, true),
          Form.Field( "checkbox", "g_almacenaje", "Almacenje", "", [], 4, [], [], [], false, true),
          Form.Field( "checkbox", "g_completo", "Completo", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_paga", "Quien paga", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_cliente", "Clave Cliente", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_rsocial", "Cliente", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "pedido", "Pedido/Remision/Manifiesto", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_rfc", "R.F.C.", "", [], 4, [], [], [], false, false),
          Form.Field( "text", "cliente_telefono", "Telefono", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_domicilio", "Domicilio Fiscal", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_colonia", "Colonia", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_ciudad", "Ciudad", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_estado", "Estado", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_cp", "C.P.", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_pedimiento", "Numero de Pedimiento", "", [], 4, [], [], [], false, true),
          Form.Section("Cobro"),
          Form.Field( "text", "g_costo_flete", "Flete", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_recoleccion", "Recoleccion", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_entrega", "Entrega", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_seguro", "Seguro", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_otros_cargos", "Otros Cargos", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_otros_cargos_recoleccion", "O. Cargos x Recoleccion", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_otros_cargos_entrega", "O.Cargos x Entrega", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_maniobras_carga", "Maniobras Carga", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_maniobras_descarga", "Maniobras Descarga", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_cpac", "CPAC", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_subtotal", "Subtotal", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_iva", "I.V.A.", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_retencion", "Retención", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "g_costo_total", "Total", "", [], 4, [], [], [], false, true),
          Form.Section("Remitente"),
          Form.Field( "text", "cliente_remitente_clve", "Clave Remitente", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_remitente_nombre", "Remitente", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_remitente_telefono", "Telefono", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_remitente_domicilio", "Domicilio", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_remitente_colonia", "Colonia", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_remitente_ciudad", "Ciudad", "", [], 4, [], [], [], false, true),
          Form.Field(  "text",  "cliente_remitente_estado",  "Estado",  "",  [],  4,  [],  [],  [],  false,  true),
          Form.Field( "text", "cliente_remitente_cp", "C.P.", "", [], 4, [], [], [], false, true),
          Form.Section("Destinatario"),
          Form.Field("text","cliente_dest_clve","Clave Destinatario","",[],4,[],[],[],false,true),
          Form.Field("text","cliente_dest_nombre","Destinatario","",[],4,[],[],[],false,true),
          Form.Field( "text", "cliente_dest_telefono", "Telefono", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_dest_domicilio", "Domicilio", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_dest_colonia", "Colonia", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_dest_ciudad", "Ciudad", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_dest_estado", "Estado", "", [], 4, [], [], [], false, true),
          Form.Field( "text", "cliente_dest_cp", "C.P.", "", [], 4, [], [], [], false, true),
          Form.Section("CFDi"),
          Form.Field("select", "cliente_cfdi_uso", "Uso CFDi", "", [Validators.required], 6),
          Form.Field("select","cliente_forma_pago","Forma de pago","",[Validators.required],6),
          Form.Field( "select", "cliente_metodo_pago", "Metodo de pago", "", [Validators.required], 6),
          Form.Field("select", "cta_deposito", "Cta de Deposito", "", [], 6),
          Form.Field("select", "cliente_id_banco", "Banco pago Cte", "", [], 6),
        ],
        ["Facturar"],
        "Facturar"
      ),
      this.formData
    );
  }

  formData = async (form) => {
    let newForm = form;
    this.initial = true;
    const Res = await Http.get(`facturacion/form?initialdata=${this.initial}&folio=${this.guiaFolio}`);

    if (!Res.error) {
      const { bancos, cfdi_usos, guias, formas_pago, metodos_pago } = Res.data;
      this.guiaFolio = false;
      if (guias) {
        newForm = Form.FieldOptions(newForm, "g_folio", guias, "id", "g_folio");
      }
      if (bancos) {
        newForm = Form.FieldOptions(
          newForm,
          "cliente_id_banco",
          bancos,
          "id",
          "banco_nombre"
        );
      }
      if (cfdi_usos) {
        newForm = Form.FieldOptions(
          newForm,
          "cliente_cfdi_uso",
          cfdi_usos,
          "id",
          "cfdi_uso_nombre"
        );
      }
      if (formas_pago) {
        newForm = Form.FieldOptions(
          newForm,
          "cliente_forma_pago",
          formas_pago,
          "id",
          "forma_nombre"
        );
      }
      if (metodos_pago) {
        newForm = Form.FieldOptions(
          newForm,
          "cliente_metodo_pago",
          metodos_pago,
          "id",
          "metodo_nombre"
        );
      }
    }

    newForm = Form.ValueChange(newForm, {
      g_folio: this.searchGuia,
    });
    this.initial = false;
    return newForm;
  };

  searchGuia = async (field) => {
    if (field.Value) {
      let Res = await Http.get(`facturacion/guia/${field.Value}`);
      this.setState({
        FormData: Form.Patch(this.state.FormData, Res.data),
      });
    } else {
      this.guiaFolio = field.ValueAt;
      if (field.ValueAt.length > 2) {
        this.setState({ FormData: await this.formData(this.state.FormData) });
      }
    }
  };

  onSubmit = async (i, vals) => {
    this.setState({ loading: true }, async () => {
      const Resp = await Http.post("facturacion/facturar", vals);
      if (!Resp.error) {
        this.setState({
          viewPdf: true,
          factura: Resp.data,
        })
      } else {
        this.setState({ loading: false, sbOpen: true, sbMsg: Resp.errMsg });
      }
    })
  };

  viewPdfClose = () => {
    this.setState({ viewPdf: false });
    this.props.history.goBack();
  };

  handledownloadPdf = () => {
    const { pdfURL } = this.state;
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = pdfURL;
    a.download = `factura.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(pdfURL);
    // this.props.history.goBack();
  }

  handleDownloadFiles = async () => {
    await this.handledownloadPdf();
    await this.handledownloadFile('xml-timbrado');
  }

  handledownloadFile = async (type) => {
    const { FormData } = this.state;
    const id_guia = FormData.Fields[0].Value;
    const Resp = await Http.post("facturacion/file", { id_guia, type }, true, "arraybuffer");
    if (Resp) {
      const blob = new Blob([Resp], { type: "application/xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `${id_guia}.xml`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      // this.props.history.goBack();
    }
  }

  render() {
    const { viewPdf, factura } = this.state;
    return (
      <div>
        <this.FormRender loading />

        <Dialog
          onClose={this.viewPdfClose}
          open={viewPdf || false}
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogTitle>Reenviar Factura</DialogTitle>
          <DialogContent>
            <EnviarFacturaEmail factura={factura} />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(Facturar);